import { useLanguageContext } from '@/context/LanguageContext';
import { en } from '@/i18n/en';
import { pt } from '@/i18n/pt';

export const useTranslation = () => {
  const { language } = useLanguageContext();
  
  const translations = {
    en,
    pt
  };

  return translations[language] || translations.en;
};